var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrphLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.705 17.208) scale(0.16183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.2844,
    cy: 45.2374,
    r: 18.6272,
    fill: "#F4EA11"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.583 5.52673L61.2037 12.4863L51.583 19.4459C48.058 19.3393 31.7988 19.4021 25.2554 19.4324C23.7186 19.4395 22.4741 20.646 22.4242 22.1819C22.2052 28.9233 21.6877 46.4391 21.9024 55.4721H7.98315C7.98315 42.8375 7.98315 17.6037 7.98315 17.6037C7.98315 6.14082 19.446 5.52673 19.446 5.52673H51.583Z",
    fill: "#1F4485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.913 74.3041C163.162 76.2347 166.826 78.8073 166.826 78.8073C166.826 78.8073 173.789 85.7721 177.47 89.0421L173.376 90.6796C167.369 90.8159 161.358 90.6793 155.363 90.2702L147.175 82.0824L145.128 81.6731C143.126 82.2114 141.061 82.4866 138.988 82.4918C130.186 83.3106 124.454 82.9012 116.881 78.8073C106.795 71.6033 101.641 61.5935 100.71 48.922C100.71 24.9534 116.084 10.6709 136.941 12.077C171.739 14.4229 175.833 48.922 161.913 74.3041Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.04 12.0769C213.291 12.0769 216.362 12.4863 218.409 12.8957H211.04V12.0769Z",
    fill: "#CF2130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.04 12.0769V12.8957H182.383V80.8542H181.564V12.0769H211.04Z",
    fill: "#CF2130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.04 12.8958C211.04 12.8958 216.362 12.8958 218.409 12.8958C218.409 12.8958 226.447 14.0221 229.872 17.399C234.431 21.8953 234.784 28.0728 234.784 34.184C234.758 37.4435 233.418 41.3369 231.509 44.0093C228.392 48.3729 223.348 48.6842 219.228 50.1501C227.62 57.3144 237.175 70.9302 243.791 80.8543H224.959L206.946 55.8816C205.984 55.1298 204.048 55.0753 202.852 55.0628C201.718 55.0747 200.354 54.9379 199.577 55.4722V80.8543H182.383V12.8958H211.04Z",
    fill: "#CF2130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.529 12.8958C264.661 12.8958 278.73 12.9841 287.659 13.0447C292.935 13.0806 298.51 12.8444 303.087 15.468C309.809 19.3209 311.727 26.9519 311.749 35.0027C311.782 46.7685 300.923 56.4009 291.28 57.1097H274.904V80.8543H258.529V12.8958Z",
    fill: "#1E4485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.118 12.8958H334.675V23.5399C334.564 28.2291 334.771 36.7463 334.851 39.6958C334.861 40.0677 335.321 40.2298 335.566 39.9498L336.313 39.0966C337.834 37.7201 339.478 36.4868 341.225 35.4121C342.454 34.5999 345.03 34.1179 347.044 33.852C348.888 33.6085 350.779 33.5606 352.564 34.0836C359.099 35.9986 364.939 42.6472 366.198 50.5595C366.198 50.5595 366.361 70.7544 366.198 80.8543H351.051C351.185 70.3885 351.451 61.5083 351.071 51.1038C351.058 50.7423 351.016 50.3819 350.903 50.0384C350.425 48.5903 348.627 44.6234 343.272 44.6234C337.984 44.6234 335.764 48.4926 335.106 49.9834C334.939 50.3597 334.88 50.7687 334.88 51.1802V80.8543H319.118V12.8958Z",
    fill: "#1E4485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4852 35.0027H86.5857V69.3913C85.8124 76.8089 80.1911 82.1466 73.4852 84.1293H44.828L35.0027 77.1697L44.828 71.0289C44.828 71.0289 61.8971 71.024 70.2101 70.2101C71.6532 69.5858 72.472 68.4944 72.6664 66.935C73.4815 56.4362 73.7546 45.7921 73.4852 35.0027Z",
    fill: "#CF2130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.156 39.9154V43.1905H119.337C119.117 41.8813 119.39 40.7894 120.156 39.9154ZM152.907 39.9154C153.672 40.7894 153.945 41.8813 153.725 43.1905H152.907V39.9154Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.337 43.1906H120.156V51.3783H119.337V43.1906Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.337 51.3783H120.156V54.6534C119.39 53.7794 119.117 52.6875 119.337 51.3783Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.156 56.2909C120.842 56.5705 121.115 57.1166 120.974 57.9284C120.288 57.6488 120.015 57.1027 120.156 56.2909Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.564 80.8542H199.577C196.724 81.3991 190.571 81.2636 190.571 81.2636C190.571 81.2636 184.417 81.3991 181.564 80.8542Z",
    fill: "#CF2130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.47 89.042L178.903 90.6795H173.376L177.47 89.042Z",
    fill: "#CF2231"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.098,
    cy: 47.2844,
    rx: 18.0131,
    ry: 23.1305,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.372 24.5634H212.327C212.927 24.5634 213.521 24.692 214.068 24.9405V24.9405C220.482 27.8561 220.961 36.7849 214.895 40.3694L214.271 40.7378C213.595 41.1375 212.824 41.3483 212.038 41.3483H199.372V24.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.513 24.9727H288.228C288.902 24.9727 289.568 25.1169 290.182 25.3958V25.3958C297.379 28.667 297.915 38.6846 291.11 42.7063L290.41 43.1196C289.651 43.568 288.786 43.8045 287.904 43.8045H274.513V24.9727Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 49,
    rx: 2.5,
    stroke: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrphLogo);
export default __webpack_public_path__ + "static/media/qrph-logo.7dc662b2defdcc09915c30dbd60a3d0a.svg";
export { ForwardRef as ReactComponent };